import { AppAlert } from '../../../components/AppAlerts/AppAlerts'
import { useAppDispatch } from '../../hooks'
import { addAlert, removeAlert } from './alertsSlice'

export const addAlertWithTimeout = (dispatch: ReturnType<typeof useAppDispatch>, alert: AppAlert, timeout?: number) => {
  dispatch(addAlert(alert.toJSON()))
  setTimeout(() => {
    dispatch(removeAlert(alert.id))
  }, timeout ?? 2500)
}